/**
 * @desc 邮件回复
 */
const URL = "/rantion-crm";
import http, { updateResponse } from "@/http";
export function request(
  ticketId: string | number,
  body: defs.crm.TicketReplyRequestDto,
  options?: any,
) {
  return updateResponse(
    http(URL + `/crm/ticket/send/${ticketId}`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
